// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__luIcb","buttons":"PendingPaymentAlert_buttons__2tcmi"};